/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { Fragment } from "react";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { getFieldValues } from "cms/fields/_helpers/helpers";
import { ImageGalleryFilmstrip } from "./image_gallery_filmstrip";

const ImageGallery = (props) => {

    const field = props?.field;
    const values = getFieldValues(field);
    const hasContent = isArrayNotEmpty(values) || isArrayNotEmpty(field);

    return (
        <div className='simplicity-image-list'>
            {hasContent &&
                <Fragment>
                    <div className='blocks'>
                        <div
                            id={`image-list-`}
                            className='block block-bean'
                        >
                            <div className='content'>
                                <ImageGalleryFilmstrip
                                    field={field}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </div>
    );
};

ImageGallery.displayName = "ImageGallery";
export { ImageGallery };
